import { EUnreadMessagesCountActionTypes } from '../../actions/unreadMessagesCount';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function unreadMessagesCountReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EUnreadMessagesCountActionTypes.Set:
      return {
        ...state,
        unreadMessagesCount: action.payload,
      };

    default:
      return state;
  }
}
